module.exports = __webpack_public_path__ + "img/sn.091e42c6.svg";